<!-- @format -->

<div class="accordion-container">
	<ng-template #filterHeading>
		<button
			class="accordion-header hmf-px-s hmf-display-flex hmf-justify-content-between hmf-align-items-center"
			[style.min-height]="collapsedHeight()"
			[style.width]="width()"
			[class]="{
				'top-border': topBorder(),
				'left-right-border': !isInline(),
				'dark-variant-bg-color': isDarkVariant(),
				'default-variant-bg-color': !isDarkVariant(),
				'hmf-subtle-shadow hide-button': hideButton()
			}"
			[attr.aria-expanded]="isExpanded()"
			[attr.aria-controls]="accordionPanelIdBase() + '-accordion-panel'"
			(click)="toggleAccordion()"
			(focus)="focusAccordion()">
			<div class="hmf-display-flex hmf-flex-column hmf-text-align-left">
				<span
					[class]="{
						'dark-variant-text-color': isDarkVariant(),
						'light-variant-text-color': !isDarkVariant(),
						'hmf-header-s hmf-ml-s': hideButton(),
						'hmf-header-bold-s': !hideButton()
					}">
					{{ header() }}
				</span>
				@if (subHeader()) {
					<div
						class="accordion-subheader"
						[class]="{
							'dark-variant-text-color': isDarkVariant(),
							'light-variant-text-color': !isDarkVariant()
						}">
						{{ subHeader() }}
					</div>
				}
			</div>
			<div class="hmf-display-flex hmf-align-items-center">
				@if (selectedCount()) {
					<span
						class="hmf-subheader-m hmf-pr-xxxs"
						[class]="{
							'dark-variant-text-color': isDarkVariant(),
							'light-variant-text-color': !isDarkVariant()
						}">
						{{ selectedCount() }}
					</span>
				}
				<homefield-icon
					class="accordion-icon"
					[attr.aria-hidden]="true"
					[class]="{ 'dark-variant-icon-color': isDarkVariant() }"
					[name]="isExpanded() ? 'chevron-up' : 'chevron-down'">
				</homefield-icon>
			</div>
		</button>
	</ng-template>
	<ng-content *ngTemplateOutlet="!hideButton() ? filterHeading : ''"></ng-content>
	<ng-content *ngTemplateOutlet="hideButton() && !isExpanded() ? filterHeading : ''"></ng-content>

	<div
		[attr.id]="accordionPanelIdBase() + '-accordion-panel'"
		[style.width]="width()"
		[class]="{
			'left-right-border': !isInline(),
			'dark-variant-text-color dark-variant-bg-color': isDarkVariant(),
			'default-variant-bg-color': !isDarkVariant(),
			'hidden-content': !isExpanded()
		}"
		[@expandContent]="isExpanded() ? 'expand' : 'collapse'">
		@if (isPanelContentEnabled()) {
			<ng-content select="customAccordionContent"></ng-content>
		}
	</div>
	@if (bottomBorder()) {
		<div
			[style.width]="width()"
			class="bottom-border"></div>
	}
</div>
